module.exports = __webpack_public_path__ + "static/img/081065d8c8904740e685fe.2e06d656.jpg";